const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Sepa24 = function Sepa24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M13.665 10.4h-2.669c0-.438-.051-.731-.154-.881-.159-.221-.597-.332-1.314-.332-.697 0-1.158.063-1.384.191-.225.128-.338.406-.338.835 0 .388.1.644.3.766.144.087.333.138.569.153l.538.038c1.154.077 1.874.13 2.161.162.912.091 1.574.334 1.984.727.323.307.515.708.577 1.202.036.296.053.632.053 1.004 0 .858-.082 1.486-.245 1.884-.297.731-.965 1.192-2.003 1.386-.436.082-1.101.123-1.997.123-1.494 0-2.535-.089-3.123-.268-.722-.218-1.198-.662-1.428-1.33C5.063 15.688 5 15.068 5 14.2h2.668v.223c0 .462.134.76.4.893.183.09.405.139.666.145h.982c.5 0 .82-.026.957-.078.246-.096.407-.251.484-.466.04-.133.06-.304.06-.513 0-.47-.17-.755-.512-.857-.129-.04-.723-.097-1.785-.168-.853-.061-1.446-.12-1.778-.177-.873-.163-1.455-.5-1.746-1.01-.255-.433-.383-1.089-.383-1.966 0-.669.069-1.204.207-1.607.138-.404.36-.71.668-.919.45-.321 1.025-.51 1.726-.566.583-.051 1.23-.077 1.941-.077 1.12 0 1.918.064 2.394.192 1.161.312 1.742 1.186 1.742 2.622 0 .118-.009.294-.026.53zM25.4 17.658V7H30.744c.733 0 1.292.06 1.676.18.88.275 1.469.839 1.771 1.69.156.448.234 1.121.234 2.02 0 1.082-.086 1.858-.258 2.332-.343.935-1.048 1.474-2.113 1.613-.126.021-.659.04-1.6.055l-.476.016h-1.71v2.752H25.4zm2.868-5.224h1.788c.567-.02.912-.064 1.036-.133.17-.093.284-.28.34-.56.036-.185.054-.463.054-.83 0-.451-.036-.786-.108-1.004-.103-.306-.35-.492-.741-.56a5.823 5.823 0 0 0-.557-.015h-1.812v3.102zM40.547 15.816h-3.835l-.515 1.842h-2.968L36.432 7h4.326L44 17.658h-2.905l-.548-1.842zm-.57-2.076-1.343-4.62-1.304 4.62h2.648z",
      fill: "#10298E",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "m24.298 9.96.098.12.066-.14.618-1.327.03-.063-.052-.049a5.518 5.518 0 0 0-3.801-1.504c-2.277 0-4.229 1.361-5.052 3.298H15.002l-.026.056-.712 1.526-.065.139h1.599a4.988 4.988 0 0 0 .006.751H15.069l-.027.057-.711 1.526-.065.139h1.977c.846 1.887 2.773 3.206 5.014 3.206 1.14 0 2.2-.342 3.077-.927l.043-.029V14.557l-.17.195a3.677 3.677 0 0 1-5.743-.263h3.829l.026-.056.712-1.527.065-.139h-5.314a3.742 3.742 0 0 1-.019-.751h5.683l.026-.056.712-1.527.064-.138H18.341a3.68 3.68 0 0 1 5.957-.336z",
      fill: "#FFBE00",
      stroke: "#10298E",
      strokeWidth: ".195",
    })
  );
};
Sepa24.defaultProps = {
  width: "48",
  height: "24",
  viewBox: "0 0 48 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Sepa24,
};
export function Sepa(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Sepa' icon. Please use one of the available sizes: '24'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
